import WidgetBase from '../widget.base';
import template from './improv.widget.pug';
import errorTemplate from './error-template.pug';
import MovieService from '../../services/movies';
import BackToTopService from '../../services/back-to-top';
import { each } from '../../lib/util';
import { pushTrackingData } from '../../lib/dataLayer';

export default class MoviesComingSoonComponent extends WidgetBase {
    static selector = '[data-js-improv]';
    static template = template;
    static fetch = MovieService.fetchImprovShows;
    static errorTemplate = errorTemplate;
    static error = {
        serviceName: 'Improv',
        directoryURL: '/shopping/stores'
    }

    constructor(el, error = false) {
        super(el);

        if (error) {
            return;
        }
        this.navMonthButtons = this.el.querySelectorAll('[data-js-nav-month]');
        this.sections = this.el.querySelectorAll('[data-js-improv-section]');

        this.improvNavs = this.el.querySelectorAll('[data-js-improv-nav]');
        this.improvNavMap = [];

        each(this.improvNavs, (nav) => {
            this.improvNavMap.push(nav.querySelectorAll('[data-js-month-display]'));
        })

        this.index = 0;
        BackToTopService.init(el, true);

        each(this.navMonthButtons, (button) => {
            button.addEventListener('click', (e) => {
                this.navigate(button);
            });
        });

        const websiteLinkSelector = '.ww-improv__contact__site > a';
        const addressLinkSelector = '.ww-improv__address';
        const showtimeLinkSelector = '[data-show-name] .showtimes__time:not([disabled])';
        const phoneLinkSelector = '.ww-improv__contact__phone > a';
        const retailerName = 'Irvine Improv';

        this.el.addEventListener('click', (e) => {
            const { target } = e;

            if (target.matches(addressLinkSelector)) {
                pushTrackingData({
                    'name': 'improv_directions'
                });
            } else if (target.matches(websiteLinkSelector)) {
                pushTrackingData({
                    'name': 'retailer_website_click',
                    'retailer_name': retailerName,
                    'click_url': target.getAttribute('href')
                });
            } else if (target.matches(showtimeLinkSelector)) {
                const card = target.closest('[data-show-name]');
                if (typeof (card) === 'undefined' || card === null) {
                    return;
                }

                const { showName } = card.dataset;
                const { dateTime } = target.dataset;

                pushTrackingData({
                    'name': 'improv_showtime',
                    'show_name': showName,
                    'showtime': dateTime
                });
            } else if (target.matches(phoneLinkSelector)) {
                pushTrackingData({
                    'name': 'retailer_phone_click',
                    'retailer_name': retailerName,
                    'click_url': target.getAttribute('href'),
                });
            }
        });
    }

    navigate(button) {
        const direction = button.dataset.jsNavMonth;

        if (direction === 'next') {
            this.next();
        } else {
            this.prev();
        }
    }

    next() {
        const newIndex = this.index + 1;
        if (newIndex >= this.sections.length) {
            return;
        }
        this.showMonth(newIndex);
    }

    prev() {
        const newIndex = this.index - 1;
        if (newIndex < 0) {
            return;
        }
        this.showMonth(newIndex);
    }

    showMonth(newIndex) {
        this.sections[this.index].classList.remove('active');
        this.sections[newIndex].classList.add('active');

        // this.monthsDisplays[this.index].classList.remove('active');
        // this.monthsDisplays[newIndex].classList.add('active');

        each(this.improvNavMap, (monthDisplays) => {
            monthDisplays[this.index].classList.remove('active');
            monthDisplays[newIndex].classList.add('active');
        })

        this.index = newIndex;
    }
}